import styled, { css } from 'styled-components'
import {
  Text,
  Popover,
  truncateStyles,
  Link,
  Skeleton,
} from '@sketch/components'
import { ColorValues } from '../../../../../../types'
import { VersionLink } from '../../../../../../../versioning'
import { ReactComponent as ChevronRight } from '@sketch/icons/chevron-right-17'

export const ClickableArea = styled(Text.Div)`
  cursor: pointer;
  min-height: auto;
  flex: none;
  font-weight: 400;
  display: flex;
  padding: 0;
  line-height: 1.462; /* stylelint-disable-line scales/line-height */
  color: ${({ theme }) => theme.colors.foreground.secondary.D};
  font-size: ${({ theme }) => theme.fontSizes.D};
`

// negative margins to make the selected background go closer to the sidebar edge
export const TriggerContainer = styled.div`
  margin: 0 -16px; /* styelint-disable-line scales/space */
  min-width: '275px';
  width: 100%;
`

export const Trigger = styled.div`
  display: flex;
  align-items: flex-start;
  height: 44px;

  line-height: 1;
  box-sizing: border-box;
  cursor: pointer;
  max-width: calc(100% + 50px);
  border-radius: ${({ theme }) => theme.radii.large};

  width: 100%;
  padding-right: 16px;
  padding-left: 16px;
  padding-top: 8px;
  padding-bottom: 8px;
`

export const ColorInfo = styled.div`
  ${truncateStyles};

  display: flex;
  flex-direction: column;
  justify-content: flex-start;
  align-self: center;
  width: 100%;
`

export const ColorName = styled(Text.Div)(
  ({ theme }) => css`
    ${truncateStyles};
    word-break: break-all;
    height: 18px; /* stylelint-disable-line scales/size */
    color: ${theme.colors.foreground.secondary.A};
    font-size: ${theme.fontSizes.D};
    font-weight: ${theme.fontWeights.regular};
  `
)

export const ColorNameInPopover = styled(ColorName)`
  font-weight: 500;
`

export const ColorPath = styled.div(
  ({ theme }) => css`
    ${truncateStyles};

    word-break: break-all;
    color: ${theme.colors.foreground.secondary.D};
    font-size: ${theme.fontSizes.B};
    font-weight: ${theme.fontWeights.medium};
  `
)

export const ColorPathInPopover = styled(ColorPath)(
  ({ theme }) => css`
    font-size: ${theme.fontSizes.C};
  `
)

export const PopupVariableInfo = styled.div`
  display: flex;
  padding: 16px;
  width: 300px;
`

export const ColorAttributeContainer = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: space-between;

  width: 300px;
  border-top: 1px solid ${({ theme }) => theme.colors.border.B};
  padding: 12px 16px;

  & > div:first-child {
    flex: 1;
    min-width: 0;
  }
`

const linkStyles = css`
  display: flex;
  align-items: center;

  font-weight: 400;
`

export const LinkStyled = styled(Link)`
  ${linkStyles}
`

export const VersionLinkStyled = styled(VersionLink)`
  ${linkStyles}
`

export const IconWrapper = styled.div(
  ({ theme }) => css`
    flex: none;

    display: flex;
    align-items: center;
    justify-content: center;

    width: 36px;
    height: 36px;
    border-radius: 6px;
    margin-right: 8px;
    background: ${theme.colors.background.tertiary.C};

    svg {
      width: 17px;
      color: ${theme.colors.foreground.secondary.D};
    }
  `
)

// We want to do this as it will adjust to the width of the space calculated
// by it's parent with flex: 2
export const StyledPopover = styled(Popover)`
  width: 100%;
`

export const Chevron = styled(ChevronRight)`
  flex: none;
  height: 17px;
  margin-left: auto;
  padding-left: 8px;
  color: ${({ theme }) => theme.colors.foreground.secondary.D};
`

export const StyledSkeleton = styled(Skeleton)`
  width: 100%;
  height: 40px;
`

export const ColorSwatch = styled.div<ColorValues>(
  ({ theme, red, green, blue, alpha }) => css`
    margin: 16px 0;
    background: rgba(${red}, ${green}, ${blue}, ${alpha});
    width: 100%;
    height: 148px;
    box-shadow:
      0 -1px 0 0 inset ${theme.colors.border.A},
      0 1px 0 0 inset ${theme.colors.border.A};
  `
)

export const FormatDetail = styled.span`
  color: ${({ theme }) => theme.colors.foreground.secondary.D};
`

export const ScreenReaderOnly = styled.div`
  display: none;
`
